// extracted by mini-css-extract-plugin
export var discard = "_5j-3";
export var muiTooltipTooltip = "_5j-5";
export var notificationBar = "_5j-2";
export var saveButtonHoverSlotWrapper = "_5j-4";
export var show = "_5j-1";
export var spacer = "_5j-0";